module.exports = __webpack_public_path__ + "static/media/icon-payment-summary.d359922d.svg";